import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FilenamePipe } from '../../../../pipes/filename.pipe';

@Component({
	selector: 'app-personalized-image-modal',
	templateUrl: './personalized-image-modal.component.html',
	styleUrls: ['./personalized-image-modal.component.scss']
})
export class PersonalizedImageModalComponent implements OnInit {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('component') componentData;
	@Output() output = new EventEmitter<any>();
	@ViewChild('mergeTag', { static: true }) mergeTag: ElementRef;
	WrapperHeight = window.innerHeight * 0.9 - 140;
	backup;
	multiBackup = [];
	multiVersion = false;
	selectedElement;
	fontName = [];

	constructor(private filenamePipe: FilenamePipe) {}

	ngOnInit() {
		this.multiVersion = this.componentData.config.version > 1 && this.componentData.config.merge_array.length != 0;

		if (this.multiVersion) {
			this.componentData.config.merge_array.forEach((item) => {
				this.multiBackup.push(JSON.parse(JSON.stringify(item)));
				const fontFileName = this.filenamePipe.transform(item.text.font);
				this.fontName.push(fontFileName.substr(0, fontFileName.length - 4));
			});
		} else {
			this.backup = {
				item_height: this.componentData.config.item_height,
				item_width: this.componentData.config.item_width,
				left_offset: this.componentData.config.parser.left_offset,
				top_offset: this.componentData.config.parser.top_offset
			};
		}
	}

	updatePosition(event, index) {
		if (this.multiVersion) {
			this.componentData.config.merge_array[index].parser.left_offset = event.left;
			this.componentData.config.merge_array[index].parser.top_offset = event.top;
		} else {
			this.componentData.config.parser.left_offset = event.left;
			this.componentData.config.parser.top_offset = event.top;
		}
	}

	updateResize(event) {
		this.componentData = event;
	}

	update() {
		this.output.emit({ method: 'update', data: this.componentData });
	}

	cancel() {
		if (this.multiVersion) {
			this.componentData.config.merge_array = this.multiBackup;
		} else {
			this.componentData.config.item_height = this.backup.item_height;
			this.componentData.config.item_width = this.backup.item_width;
			this.componentData.config.parser.left_offset = this.backup.left_offset;
			this.componentData.config.parser.top_offset = this.backup.top_offset;
		}
		this.output.emit({ method: 'cancel', data: this.componentData });
	}

	reset() {
		// deprecated
		this.componentData.config.item_height = 100;
		this.componentData.config.item_width = 100;
		this.componentData.config.parser.left_offset = 0;
		this.componentData.config.parser.top_offset = 0;
	}

	toggleFocus(elm) {
		this.selectedElement = elm;
	}
}
